export const defaultSortKey = 'maxFavoriteAdded'
export const sortKeys = ['maxFavoriteAdded', 'brand', 'firstPrice', 'name']
export const defaultSortAndFilter = {
  sortKey: defaultSortKey,
  filter: {
    brand: undefined,
    availability: undefined,
  },
  features: {
    showQrCodes: false,
    showImages: false,
  },
}

export const defaultFilterData = {
  brand: {},
  availability: {},
  sort: sortKeys,
}
